module.exports = __webpack_public_path__ + "static/media/f7.3c379679.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feather/f7.png
// module id = 1218
// module chunks = 0